import { render, staticRenderFns } from "./index.vue?vue&type=template&id=889393dc&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('889393dc')) {
      api.createRecord('889393dc', component.options)
    } else {
      api.reload('889393dc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=889393dc&", function () {
      api.rerender('889393dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/system-manage/account-manage/index.vue"
export default component.exports